import {
  API_CONFIGS_URL,
} from './urls';
import callWebApi from './callWebApi';

export const GET_CONFIGS = 'GET_CONFIGS';
export const GET_CONFIGS_FAILURE = 'GET_CONFIGS_FAILURE';
export const GET_CONFIGS_SUCCESSFUL = 'GET_CONFIGS_SUCCESSFUL';


export const getConfigs = () => async (dispatch, getState) => {
  dispatch({ type: GET_CONFIGS });
  let response;
  try {
    const { authToken } = getState();
    response = await callWebApi('GET', API_CONFIGS_URL, null, authToken);
    dispatch({
      type: GET_CONFIGS_SUCCESSFUL,
      payload: response.configs,
    });
  } catch (err) {
    dispatch({
      type: GET_CONFIGS_FAILURE,
      error: err,
    });
    throw err;
  }
  return response;
};



// WEBPACK FOOTER //
// ./src/actions/configs.js